__turbopack_export_value__({
  "blogCard": "Articles-module__ZryReG__blogCard",
  "blogThumb": "Articles-module__ZryReG__blogThumb",
});
